export default __webpack_public_path__ + "static/media/LabelIconWhite.d523f909.svg";